import { KemConsentFormControllerService } from "@ch/generated";
import { NotifySuccess } from "@ch/helpers/utils/helpers";
import { handleError } from "@ch/helpers/utils/handleError";
import type { AppState } from "@ch/redux-store/root-reducer";
import { useSelector } from "react-redux";
import useLoading from "./useLoading";

interface TAddConsentRequestBody {
  guardianName: string;
  phone: string;
  countryCode: string;
  email: string;
}

interface TInitiateAddConsent {
  requestBody: TAddConsentRequestBody;
  onSuccess?: () => void;
  onFailure?: () => void;
}

const useAddConsent = () => {
  const { loading, startLoading, stopLoading } = useLoading();
  const currentUser = useSelector((s: AppState) => s.user.currentUser);

  const initiateAddConsent = async ({
    requestBody,
    onSuccess,
    onFailure,
  }: TInitiateAddConsent) => {
    startLoading();
    try {
      await KemConsentFormControllerService.kemConsentFormControllerCreate({
        requestBody: {
          userId: currentUser?.id,
          guardianName: requestBody.guardianName,
          guardianPhoneNumber: requestBody.phone,
          guardianEmail: requestBody.email,
        },
      });

      NotifySuccess("Consent request submitted");
      onSuccess?.();
    } catch (error) {
      handleError(error, undefined, true);
      onFailure?.();
    } finally {
      stopLoading();
    }
  };

  return { loading, initiateAddConsent };
};

export default useAddConsent;
